// @flow

import * as types from '../actionTypes';
import genericReducer, { genericSelectorSet, useGeneric } from './generic';
import type { paymentMethodType } from '../../types';
import { paymentMethod } from '../schemata';

const paymentMethods = genericReducer(types.GET_PAYMENT_METHOD_ASYNC);

export default paymentMethods;

export const selectPaymentMethod = genericSelectorSet<paymentMethodType>(
  paymentMethod,
  state => state.paymentMethods,
);

export const usePaymentMethods = useGeneric<paymentMethodType>(
  paymentMethod,
  state => state.paymentMethods,
);
